<div
  class="flex grow"
  [ngClass]="{ 'border-l border-solid border-slate-300': !first() }"
></div>
<div
  class="flex h-6 w-6 items-center justify-center rounded-full p-1 text-white"
  [ngClass]="{ 'bg-slate-500': !active(), 'bg-primary-500': active() }"
>
  <ng-content />
</div>
<div
  class="flex grow"
  [ngClass]="{ 'border-l border-solid border-slate-300': !last() }"
></div>
